<div class="form-field">
  @if (props['label']) {
  <label [for]="id" class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }
  <div class="color-field-row">
    <input [id]="id" class="color-swatch" type="color" [formControl]="formControl" [formlyAttributes]="field" />
    <span class="color-hex">{{ formControl.value }}</span>
  </div>
  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }
</div>
